module.exports = __webpack_public_path__ + "assets/img/article.8b36b01b.png";